import axios from 'axios';
const getCurrentCitySessionId = () => {
  return localStorage.getItem('sessionId') || 'foshan';
};

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器，添加 sessionId 参数
api.interceptors.request.use(config => {
  const sessionId = getCurrentCitySessionId();

  // 确保 params 存在
  config.params = config.params || {};
  config.params.sessionId = sessionId;

  return config;
}, error => {
  return Promise.reject(error);
});

export default api;